module.exports = "/virtual-football-league/img/amblems/right/logos/FakeSheffield.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/FakeSheffield.png
// module id = 2177
// module chunks = 4